import type { GetObligationOversightResultByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetObligationOversightResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationOversightResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationOversightResultByIdArgs = { id: string };

export const useGetObligationOversightResultById = createQueryHook<
  UseGetObligationOversightResultByIdArgs,
  GetObligationOversightResultByIdResponseRow[],
  GetObligationOversightResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.assessment.obligationOversightResultById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ obligation_oversight_result: data }),
  graphqlDocument: GetObligationOversightResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
